import { API } from './api';
import { DimaContext } from './DimaContext';
import { Prompt, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import ClientDataContracts from './components/datacontracts/clientDataContracts';
import DataContracts from './components/datacontracts/dataContracts';
import DataGuide from './components/dataGuide/dataGuide';
import DataQA from './components/dataQA/dataQA';
import DataSourceContainer from './components/dataSources/dataSourceContainer';
import EditableTable from './components/editableTable/editableTable';
import GroovyFuncs from './components/groovyFuncs';
import Home from './pages/home';
import IngestionDashboard from './components/ingestion/ingestionDashboard';
import Login from './pages/login';
import PatientViewer from './components/dataQA/patientViewer';
import React, { useContext } from 'react';
import RequestAccess from './pages/requestAccess';
import Resources from './pages/resources';
import Summary from './components/summary/summary';
import SummaryQA from './components/dataQA/summaryQA';
import ValidateFile from './components/validateFile';
import ValidateSingleResource from './components/validateSingleResource';
import ValidationRules from './components/hl7ValidationRules/hl7ValidationRules';

const Routes = props => {
  const context = useContext(DimaContext);
  const location = useLocation();

  const urlClientId = location.pathname.match(/^\/map\/.*/)
    ? location.pathname.split('/')[2] || null
    : null;
  const idMismatch = context.client == null || urlClientId !== context.client.id;

  if (urlClientId != null && idMismatch) {
    // eslint-disable-next-line promise/catch-or-return,promise/prefer-await-to-then
    API.get(`/client/${urlClientId}`).then(res => {
      context.setClient(res.data);
      return window.location.reload();
    });
  }

  return (
    <>
      <Prompt
        when={context.unsavedGroovyChanges}
        message={() => 'Are you sure you would like to continue without saving your changes?'}
      />
      <Switch>
        <Route path="/resources/:client_id">
          <Resources />
        </Route>
        <Route path="/validate/fhir">
          <ValidateSingleResource />
        </Route>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/request-access">
          <RequestAccess />
        </Route>
        <Route path="/validate/file">
          <ValidateFile />
        </Route>
        <Route path="/dataContracts">
          <DataContracts />
        </Route>
        {process.env.REACT_APP_FEATURE_HL7_DATA_GUIDE && (
          <Route path="/hl7DataGuide">
            <DataGuide />
          </Route>
        )}
        <Route path="/hl7-validation-rules">
          <ValidationRules />
        </Route>

        <Route exact path="/map/:client_id">
          <Redirect to={`/map/${urlClientId}/summary`} />
        </Route>
        <Route path="/map/:client_id/summary">
          <Summary client={context.client} />
        </Route>
        <Route path="/map/:client_id/mappings">
          <EditableTable client={context.client} />
        </Route>
        <Route path="/map/:client_id/data_sources">
          <DataSourceContainer client={context.client} />
        </Route>
        <Route path="/map/:client_id/groovy_library">
          <GroovyFuncs
            client={context.client}
            handleUnsavedGroovyChanges={props.handleUnsavedGroovyChanges}
            unsavedGroovyChanges={context.unsavedGroovyChanges}
          />
        </Route>
        <Route path="/map/:client_id/fhir_server_viewer">
          <DataQA client={context.client} />
        </Route>
        <Route path="/map/:client_id/patient_viewer">
          <PatientViewer client={context.client} />
        </Route>
        <Route path="/map/:client_id/reference_viewer">
          <SummaryQA client={context.client} />
        </Route>
        <Route path="/map/:client_id/ingestion">
          <IngestionDashboard client={context.client} />
        </Route>
        <Route path="/map/:client_id/data_contracts">
          <ClientDataContracts client={context.client} />
        </Route>

        {/* "/" path MUST be last or routes described below will not render */}
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </>
  );
};

export default Routes;
